import { analytics, EVENT_NAMES } from 'services/Analytics/Analytics'
import type { CartUpsellGeneration } from '../cartUpsells.schemas'
import type { AiWallUpsell, AiWallUpsellId } from './aiWall.types'

type AiWallAnalyticsUpsell = Pick<
  AiWallUpsell<AiWallUpsellId>,
  'id' | 'templateSlug'
>
type AiWallJob = Pick<
  CartUpsellGeneration<AiWallUpsellId>,
  'jobId' | 'startedAt'
>

type SourceAnalyticsProps = Record<string, unknown>

function getAiWallAnalyticsProps(
  { id, templateSlug }: AiWallAnalyticsUpsell,
  sourceAnalyticsProps: SourceAnalyticsProps
) {
  return {
    'Upsell ID': id,
    'Template Slug': templateSlug,
    ...sourceAnalyticsProps,
  }
}

function getAiWallJobAnalyticsProps({ jobId, startedAt }: AiWallJob) {
  return {
    'Job ID': jobId,
    'Duration Seconds': Math.round((Date.now() - startedAt) / 1000),
  }
}

export function trackAiWallGenerationStarted(
  upsell: AiWallAnalyticsUpsell,
  sourceAnalyticsProps: SourceAnalyticsProps,
  jobId: string
): void {
  analytics.track(EVENT_NAMES.CART_UPSELL_GENERATION_STARTED, {
    ...getAiWallAnalyticsProps(upsell, sourceAnalyticsProps),
    'Job ID': jobId,
  })
}

export function trackAiWallGenerationCompleted(
  upsell: AiWallAnalyticsUpsell,
  sourceAnalyticsProps: SourceAnalyticsProps,
  job: AiWallJob
): void {
  analytics.track(EVENT_NAMES.CART_UPSELL_GENERATION_COMPLETED, {
    ...getAiWallAnalyticsProps(upsell, sourceAnalyticsProps),
    ...getAiWallJobAnalyticsProps(job),
  })
}

export function trackAiWallSubmitFailed(
  upsell: AiWallAnalyticsUpsell,
  sourceAnalyticsProps: SourceAnalyticsProps,
  errorCode: string
): void {
  analytics.track(EVENT_NAMES.CART_UPSELL_GENERATION_FAILED, {
    ...getAiWallAnalyticsProps(upsell, sourceAnalyticsProps),
    'AI Error Code': errorCode,
  })
}

export function trackAiWallGenerationFailed(
  upsell: AiWallAnalyticsUpsell,
  sourceAnalyticsProps: SourceAnalyticsProps,
  job: AiWallJob,
  errorCode: string
): void {
  analytics.track(EVENT_NAMES.CART_UPSELL_GENERATION_FAILED, {
    ...getAiWallAnalyticsProps(upsell, sourceAnalyticsProps),
    ...getAiWallJobAnalyticsProps(job),
    'AI Error Code': errorCode,
  })
}
